import { combineReducers } from 'redux';

import feedbacks from './feedbacks';
import requests from './requests';
import rating from './rating';

export default combineReducers({ feedbacks, requests, rating });
